@if (instruction !== undefined) {
  <p-table
    [value]="instruction().nodes"
    [columns]="instructionColumns()"
    [editingRowKeys]="editingRowKeys"
    editMode="row"
    dataKey="position"
    (onRowReorder)="onRowReorder($event)"
    class="p-3 tableHeaderAlignTop"
    [scrollable]="true"
  >
    <ng-template #caption>
      <div class="flex justify-content-between">
        <span>{{ "butler_programming.instructions.title" | translate }}</span>
        <div class="flex gap-2">
          <app-button buttonText="butler_programming.instructions.save" (click)="saveInstructions()"></app-button>
          <app-svg-icon
            iconName="plus"
            iconColor="primary"
            style="align-content: center"
            class="pointer"
            (click)="addInstruction()"
          ></app-svg-icon>
        </div>
      </div>
    </ng-template>
    <ng-template #header let-columns>
      <tr>
        @if (instruction().nodes.length > 0) {
          <th style="width: 3%"></th>
          <th style="width: 3%"></th>
          <th style="width: 3%"></th>
        }

        @for (col of columns; track col) {
          <th>
            {{ col.header | translate }}
          </th>
        }
        <th></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template #body let-rowData let-rowIndex="rowIndex" let-editing="editing" let-columns="columns">
      <tr
        [pReorderableRow]="rowIndex"
        [pEditableRow]="rowData"
        [ngClass]="{ thenRow: checkIfThenLine(rowIndex, rowData) }"
      >
        <td>
          <div pReorderableRowHandle style="cursor: move">
            <app-svg-icon iconName="drag_and_drop" iconColor="primary"></app-svg-icon>
          </div>
        </td>
        <td>
          @if (rowIndex > 0) {
            <app-svg-icon (click)="onRowUp(rowIndex)" iconName="arrow_up" iconColor="primary"></app-svg-icon>
          }
        </td>
        <td>
          @if (rowIndex < instruction().nodes.length - 1) {
            <app-svg-icon (click)="onRowDown(rowIndex)" iconName="arrow_down" iconColor="primary"></app-svg-icon>
          }
        </td>
        <td>
          <p-cellEditor>
            <ng-template #input>
              <p-select
                [options]="logicOptions()"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                [(ngModel)]="rowData.logic"
              >
                <ng-template let-logic #selectedItem>
                  {{ logic.label | translate }}
                </ng-template>
                <ng-template #item let-logic>
                  {{ logic.label | translate }}
                </ng-template>
              </p-select>
            </ng-template>
            <ng-template #output>
              {{ "butler_programming.instructions.logicOptions." + rowData.logic | translate }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td>
          <p-cellEditor>
            <ng-template #input>
              <p-select [options]="definitions()" appendTo="body" [(ngModel)]="rowData.definition" />
            </ng-template>
            <ng-template #output>
              {{ rowData.definition?.label }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template #input>
              <input pInputText type="text" [(ngModel)]="rowData.notes" />
            </ng-template>
            <ng-template #output>
              {{ rowData.notes }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="min-width: 90px">
          <p-cellEditor>
            <ng-template #input>
              @if (rowData.definition && isThenNode(rowData) && rowData.definition.type !== "Timer") {
                <p-select
                  [options]="valueOptionsForNode(rowData)"
                  optionLabel="label"
                  optionValue="value"
                  appendTo="body"
                  [(ngModel)]="rowData.value"
                >
                  <ng-template let-opt #selectedItem>
                    {{ opt.label | translate }}
                  </ng-template>
                  <ng-template let-opt #item>
                    {{ opt.label | translate }}
                  </ng-template>
                </p-select>
              }
            </ng-template>
            <ng-template #output>
              @if (rowData.definition && isThenNode(rowData) && rowData.definition.type !== "Timer") {
                {{ valueLabelKeyForNode(rowData, rowData.value === true) | translate }}
              }
            </ng-template>
          </p-cellEditor>
        </td>

        @if (!editing) {
          <td>
            <app-svg-icon
              iconName="edit"
              iconColor="primary"
              class="pointer"
              pInitEditableRow
              (click)="onRowEditInit(rowData)"
            >
            </app-svg-icon>
          </td>
          <td>
            <app-svg-icon
              iconName="trash"
              iconColor="primary"
              class="pointer"
              (click)="onRowDelete(rowData)"
            ></app-svg-icon>
          </td>
        }
        @if (editing) {
          <td>
            <app-svg-icon
              iconName="check"
              iconColor="primary"
              class="pointer"
              pSaveEditableRow
              (click)="onRowEditSave(rowData)"
            ></app-svg-icon>
          </td>
          <td>
            <app-svg-icon
              iconName="x"
              iconColor="primary"
              pCancelEditableRow
              class="pointer"
              (click)="onRowEditCancel(rowData)"
            ></app-svg-icon>
          </td>
        }
      </tr>
    </ng-template>
  </p-table>
}
